import SubcontractorRouteTransactionsTable from "pages/subcontractorRouteTransactions/components/SubcontractorRouteTransactionsTable";
import React, { Fragment, useState } from "react";
import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Tab,
  Tabs,
} from "@material-ui/core";
import TabPanel from "../../routeplans/components/TabPanel";
import SubcontractorPurchaseInvoiceTable from "../../subcontractorPurchaseInvoices/components/SubcontractorPurchaseInvoiceTable";
import { StyledButton } from "../../../components/ListShowButton";

interface IDetailButton {
  purchaseInvoiceSummaryId: number;
  subcontractorId?: number;
  referenceResource: string;
  disabled?: boolean;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "auto",
      minHeight: "80vh",
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
  },
});

const DetailButton = ({
  purchaseInvoiceSummaryId,
  referenceResource,
  subcontractorId,
  disabled = false,
}: IDetailButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const [valueListTab, setValueListTab] = useState(0);

  const classes = useStyles();
  const handleOpenDialog = () => {
    if (disabled) return; // prevent opening if disabled
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setValueListTab(newValue);
  };
  const ListTabProps = (index: number) => {
    return {
      id: `list-tab-${index}`,
      "aria-controls": `list-tabpanel-${index}`,
    };
  };

  return (
    <Fragment>
      <StyledButton 
        variant="outlined" 
        onClick={handleOpenDialog} 
        disabled={disabled}
      >
        Detail
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {referenceResource === "subcontractorRouteTransactions"
            ? "Route Transactions"
            : "Purchase Invoices"}
        </DialogTitle>
        <DialogContent>
          <Tabs
            value={valueListTab}
            onChange={handleChangeListTab}
            aria-label="List"
            className={classes.sidePanelTabs}
          >
            <Tab label="Pending" {...ListTabProps(0)} />
            <Tab label="Approved" {...ListTabProps(1)} />
            <Tab label="Rejected" {...ListTabProps(2)} />
          </Tabs>

          {referenceResource === "subcontractorRouteTransactions" ? (
            <>
              <TabPanel value={valueListTab} index={0}>
                <SubcontractorRouteTransactionsTable
                  purchaseInvoiceSummaryId={purchaseInvoiceSummaryId}
                  subcontractorId={subcontractorId}
                  status="Pending"
                  isFixedHeight
                />
              </TabPanel>
              <TabPanel value={valueListTab} index={1}>
                <SubcontractorRouteTransactionsTable
                  purchaseInvoiceSummaryId={purchaseInvoiceSummaryId}
                  subcontractorId={subcontractorId}
                  status="Approved"
                  isFixedHeight
                />
              </TabPanel>
              <TabPanel value={valueListTab} index={2}>
                <SubcontractorRouteTransactionsTable
                  purchaseInvoiceSummaryId={purchaseInvoiceSummaryId}
                  subcontractorId={subcontractorId}
                  status="Rejected"
                  isFixedHeight
                />
              </TabPanel>
            </>
          ) : (
            <>
              <TabPanel value={valueListTab} index={0}>
                <SubcontractorPurchaseInvoiceTable
                  subcontractorId={subcontractorId}
                  purchaseInvoiceSummaryId={purchaseInvoiceSummaryId}
                  statusIn={["Draft"]}
                  isFixedHeight
                />
              </TabPanel>
              <TabPanel value={valueListTab} index={1}>
                <SubcontractorPurchaseInvoiceTable
                  subcontractorId={subcontractorId}
                  purchaseInvoiceSummaryId={purchaseInvoiceSummaryId}
                  statusIn={["Approved", "Unposted", "Posted"]}
                  isFixedHeight
                />
              </TabPanel>
              <TabPanel value={valueListTab} index={2}>
                <SubcontractorPurchaseInvoiceTable
                  subcontractorId={subcontractorId}
                  purchaseInvoiceSummaryId={purchaseInvoiceSummaryId}
                  statusIn={["Rejected"]}
                  isFixedHeight
                />
              </TabPanel>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DetailButton;
